import { IQueryFilterCriteria } from '../../../../interfaces/IQuery';
import { ValueControls } from '../value-controls/ValueControls';
import { ValueControlsType } from '../../../../utilities/Constants';

export interface ITriggerFilterCriteriaValueControlsProps {
    item: IQueryFilterCriteria;
    onDateRangeChange: (item: IQueryFilterCriteria, field: string, value: string) => void;
    onRelativeDateChange: (item: IQueryFilterCriteria, value: number) => void;
    onNumericRangeChange: (
        item: IQueryFilterCriteria,
        field: string,
        value: number| string | undefined
    ) => void;
    onSelectorChange: (item: IQueryFilterCriteria, options: any) => void;
    onTextChange: (item: IQueryFilterCriteria, value: string) => void;
    onYesNoChange: (item: IQueryFilterCriteria, option: any) => void;
}

export function TriggerFilterCriteriaValueControls(
    props: ITriggerFilterCriteriaValueControlsProps
) {
    return <ValueControls {...props} type={ValueControlsType.Criteria} />;
}
